module.exports = __webpack_public_path__ + "static/media/vita.9770afae.webp";